module.exports = __webpack_public_path__ + "img/cazana-logo-purple.b1befa24.svg";